
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Users, FileText } from "lucide-react";

const AffiliateBenefits = () => {
  return (
    <div className="grid md:grid-cols-3 gap-6 mb-12">
      <Card className="text-center">
        <CardHeader>
          <DollarSign className="w-12 h-12 text-primary-dark mx-auto mb-2" />
          <CardTitle className="text-lg">Competitive Commission</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            Earn 2-5% commission on successful referrals, with potential increases based on service type and volume
          </p>
        </CardContent>
      </Card>

      <Card className="text-center">
        <CardHeader>
          <Users className="w-12 h-12 text-primary-dark mx-auto mb-2" />
          <CardTitle className="text-lg">Growing Network</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            Join a network of successful partners across Texas
          </p>
        </CardContent>
      </Card>

      <Card className="text-center">
        <CardHeader>
          <FileText className="w-12 h-12 text-primary-dark mx-auto mb-2" />
          <CardTitle className="text-lg">Marketing Support</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">
            Access approved promotional materials and marketing resources
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AffiliateBenefits;
